module.exports = __webpack_public_path__ + "img/monster-3.a87dbf7b.png";